import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex _gap-1 _tc--accent" }
const _hoisted_2 = { class: "_flex _ai-c _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_key_value_list = _resolveComponent("base-key-value-list")
  const _component_base_collapsible = _resolveComponent("base-collapsible")

  return (_openBlock(), _createBlock(_component_base_collapsible, {
    rounded: false,
    class: "_tc--accent"
  }, {
    trigger: _withCtx(({ isExpanded }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_icon, {
          name: isExpanded ? 'chevron-up' : 'chevron-down'
        }, null, 8 /* PROPS */, ["name"]),
        (!isExpanded)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString($options.showDetailsLabel), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString($options.hideDetailsLabel), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    "header-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_text, {
          as: "a",
          href: $options.formattedYourPledgeUrl,
          level: "b2",
          class: "_cur-p _ttl _tc--accent"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.NotificationViewYourPledgeActionButton) + " ", 1 /* TEXT */),
            _createVNode(_component_base_icon, {
              name: "chevron-right",
              size: "sm"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_base_key_value_list, {
        items: $options.additionalInformationList,
        class: "_mt-2"
      }, null, 8 /* PROPS */, ["items"])
    ]),
    _: 1 /* STABLE */
  }))
}